enum AnimalType {
  childbirth = 'childbirth',
  designation = 'designation',
  pregnancy = 'pregnancy',
  separation = 'separation',
  breeding = 'breeding',
  seeding = 'seeding',
  insemination = 'insemination',
  castration = 'castration',
  exclusion = 'exclusion',
  movement = 'movement',
  grazing = 'grazing',
  weighing = 'weighing',
  weighing_measuring = 'weighing_measuring',
  starter_feed = 'starter_feed',
  weaning = 'weaning',
  dry_off = 'dry_off',
  other = 'other',
  service = 'service',
  embryo_transfer = 'embryo_transfer',
  change_owner = 'change_owner',
  imported = 'imported',
  flushing = 'flushing',
  slaughtered = 'slaughtered',
  deceased = 'deceased',
  missing = 'missing',
  died = 'died',
}

export default AnimalType;
